<template>
  <div>
    <b-form-group
        label-for="input-6"
        class="custom-label"
    >
      <label-info
          id="popover-target-exercise-level"
          :label-name="fieldName"
          label-info="The Level that you are now"
      />
      <b-dropdown
          id="dropdown-header"
          :text="fieldName"
          block
          variant="primary"
          split
          split-variant="outline-primary"
          class="m-2"
          menu-class="w-100"
      >
        <b-dropdown-header v-if="false" id="dropdown-header-label">
          Dropdown header
        </b-dropdown-header>
        <template #button-content>
           <span
           v-if="selectedOption"
           >
             {{selectedOption.text}}
           </span>
          <strong v-else>
            Select {{ selectWord }}
          </strong>
        </template>
        <b-dropdown-item-button
            v-for="(anOption, i) in fieldOptions"
            aria-describedby="dropdown-header-label"
            @click="handleItemButtonClick(anOption)"
            :key="`level-${i}`"
        >
          <b-row>
            <b-col>
              <b-avatar
                  v-if="anOption.imgURL"
                  :src="anOption.imgURL"
                  square />
              {{anOption.text}}
            </b-col>
          </b-row>
          <b-row>
            <b-col v-if="anOption.description">
              <small>
                {{anOption.description}}
              </small>
            </b-col>
          </b-row>
        </b-dropdown-item-button>
      </b-dropdown>
      <pre
          v-if="!production"
          class="mt-3 mb-0"
      >
        {{ selectedOption }}
      </pre>
    </b-form-group>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import LabelInfo from "@/components/blockResources/_components/labelInfo";
export default {
  name: "DropDownField",
  components: {
    LabelInfo
  },
  props: {
    fieldName: {
      type: String,
      default: 'Exercise Level',
      required: true
    },
    fieldKey: {
      type: String,
      default: 'exercise_level',
      required: true
    },
    selectWord: {
      type: String,
      default: 'Level',
      required: true
    },
    optionsJson: {
      type: Object,
      default: ()=>{return {}},
      required: true
    },
    selectedValue: {
      type: String,
      default: 'level',
      required: true
    },  },
  computed: {
    ...mapGetters({
    }),
    selectedOption(){
      return this.fieldOptions && Array.isArray(this.fieldOptions) ? this.fieldOptions.filter((anOption) =>{
        return anOption.value === this.selectedValue;
      })[0] : null;
    }
  },
  mounted(){
    this.setFieldOptions();
  },
  methods: {
    setFieldOptions(){
      this.fieldOptions =  this.optionsJson && this.optionsJson[this.fieldKey] &&
      this.optionsJson[this.fieldKey].items && Array.isArray(this.optionsJson[this.fieldKey].items) ?
          this.optionsJson[this.fieldKey].items : [];
    },
    handleItemButtonClick(theOption){
      debugger;
      //this.selectedOption = theOption;
      this.$emit('selected-option',
          {
            key: this.fieldKey,
            option: theOption
          }
      );
    }
  },
  data() {
    return {
      production: true,
      fieldOptions: null,
    };
  }
};
</script>

<style lang="scss" scoped>
small {
  white-space: pre-wrap;
  white-space: -moz-pre-wrap;
  white-space: -pre-wrap;
  white-space: -o-pre-wrap;
  word-wrap: break-word;
}
</style>
